document.addEventListener('DOMContentLoaded', function () {
  var tools = document.querySelectorAll('.footer__ai-tool');

  tools.forEach(function (tool) {
    tool.addEventListener('pointermove', function (event) {
      var rect = tool.getBoundingClientRect();
      var x = event.clientX - rect.left - rect.width / 2;
      var y = event.clientY - rect.top - rect.height / 2;
      // Rotate the bright conic segment toward the pointer - shared by the
      // AI-icon rings and the masked wordmark glow.
      var angle = Math.atan2(y, x) * (180 / Math.PI) + 90;
      tool.style.setProperty('--glow-angle', angle + 'deg');
    });
  });
});
